const getStorageKey = (loginName: string) => `crm:contract-report-fields:${encodeURIComponent(loginName)}`

export const loadContractReportFieldNames = (loginName: string): string[] => {
    if (!loginName) return []

    try {
        const storedFields: unknown = JSON.parse(localStorage.getItem(getStorageKey(loginName)) || '[]')
        if (!Array.isArray(storedFields) || storedFields.some((fieldName) => typeof fieldName !== 'string')) {
            return []
        }

        const fieldNames = (storedFields as string[]).map(fieldName => (
            fieldName === 'print_status_id' ? 'print_status_name' : fieldName
        ))
        return [...new Set(fieldNames)]
    } catch {
        return []
    }
}

export const saveContractReportFieldNames = (loginName: string, fieldNames: string[]): boolean => {
    if (!loginName) return false

    try {
        localStorage.setItem(getStorageKey(loginName), JSON.stringify([...new Set(fieldNames)]))
        return true
    } catch {
        return false
    }
}